/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type RoutesQueryVariables = {};
export type RoutesQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly roles: ReadonlyArray<{
                readonly name: string;
            }>;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"sidebarMenu_viewer" | "PrivateRoute_viewer" | "NotificationBar_viewer">;
    };
};
export type RoutesQuery = {
    readonly response: RoutesQueryResponse;
    readonly variables: RoutesQueryVariables;
};



/*
query RoutesQuery {
  viewer {
    ...sidebarMenu_viewer
    ...PrivateRoute_viewer
    ...NotificationBar_viewer
    user {
      roles {
        name
        id
      }
      id
    }
  }
}

fragment NotificationBar_viewer on Viewer {
  broadcastNotifications(first: 3, read: false, cancelled: false, expired: false, delivered: true) {
    total
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        read {
          createdAt
        }
        broadcast {
          message
          title
          id
        }
        __typename
      }
      cursor
    }
  }
}

fragment PrivateRoute_viewer on Viewer {
  user {
    roles {
      name
      id
    }
    id
  }
}

fragment sidebarMenu_viewer on Viewer {
  notifications {
    unreadBroadcastNotifications
    id
  }
  user {
    username
    entities {
      accountName
      id
    }
    roles {
      name
      id
    }
    isHub
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "cancelled",
    "value": false
  },
  {
    "kind": "Literal",
    "name": "delivered",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "expired",
    "value": false
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  },
  {
    "kind": "Literal",
    "name": "read",
    "value": false
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Role",
                "kind": "LinkedField",
                "name": "roles",
                "plural": true,
                "selections": [
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "sidebarMenu_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PrivateRoute_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NotificationBar_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RoutesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ViewerNotifications",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unreadBroadcastNotifications",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "username",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Entity",
                "kind": "LinkedField",
                "name": "entities",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountName",
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Role",
                "kind": "LinkedField",
                "name": "roles",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isHub",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "BroadcastNotificationConnection",
            "kind": "LinkedField",
            "name": "broadcastNotifications",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "total",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BroadcastNotificationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BroadcastNotification",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BroadcastNotificationRead",
                        "kind": "LinkedField",
                        "name": "read",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Broadcast",
                        "kind": "LinkedField",
                        "name": "broadcast",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "broadcastNotifications(cancelled:false,delivered:true,expired:false,first:3,read:false)"
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "filters": [
              "read",
              "cancelled",
              "expired",
              "delivered"
            ],
            "handle": "connection",
            "key": "NotificationBar_broadcastNotifications",
            "kind": "LinkedHandle",
            "name": "broadcastNotifications"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "19d25baff7005c14fc35bc428c17bd44",
    "id": null,
    "metadata": {},
    "name": "RoutesQuery",
    "operationKind": "query",
    "text": "query RoutesQuery {\n  viewer {\n    ...sidebarMenu_viewer\n    ...PrivateRoute_viewer\n    ...NotificationBar_viewer\n    user {\n      roles {\n        name\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment NotificationBar_viewer on Viewer {\n  broadcastNotifications(first: 3, read: false, cancelled: false, expired: false, delivered: true) {\n    total\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      node {\n        id\n        read {\n          createdAt\n        }\n        broadcast {\n          message\n          title\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment PrivateRoute_viewer on Viewer {\n  user {\n    roles {\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment sidebarMenu_viewer on Viewer {\n  notifications {\n    unreadBroadcastNotifications\n    id\n  }\n  user {\n    username\n    entities {\n      accountName\n      id\n    }\n    roles {\n      name\n      id\n    }\n    isHub\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ddd5b655ef66f887816cc650b8a05294';
export default node;
